import { jsxs as s, jsx as n } from "react/jsx-runtime";
import { c } from "../clsx-OuTLNxxd.js";
import { B as d } from "../Badge-U9u-iOJu.js";
import { a as v } from "../Tooltip-CPBV-bV3.js";
import '../Comparison.css';const C = "_comparisonContainer_196l8_32", f = "_valuesContainer_196l8_41", u = "_value_196l8_41", $ = "_label_196l8_49", b = "_leftBadge_196l8_59", N = "_rightBadge_196l8_63", w = "_progressBarContainer_196l8_87", A = "_hasMiddleValue_196l8_93", R = "_progressBar_196l8_87", x = "_leftBar_196l8_100", y = "_rightBar_196l8_103", M = "_separatorContainer_196l8_125", W = "_middleBadge_196l8_138", j = "_badgeRightAligned_196l8_151", a = {
  comparisonContainer: C,
  valuesContainer: f,
  value: u,
  label: $,
  leftBadge: b,
  rightBadge: N,
  progressBarContainer: w,
  hasMiddleValue: A,
  progressBar: R,
  leftBar: x,
  rightBar: y,
  separatorContainer: M,
  middleBadge: W,
  badgeRightAligned: j
}, q = (o, t = "Comparison") => {
  const i = o.reduce((r, l) => r + l, 0), e = 100;
  return i !== e ? (console.warn(`${t} component: The sum of values must equal ${e}. Current sum: ${i}`), !1) : !0;
}, k = ({
  comparisonLabel: o,
  leftValue: t,
  middleText: i = "DRAW",
  middleValue: e = 0,
  rightValue: r,
  tooltipText: l,
  ...g
}) => {
  if (!q([t, e, r]))
    return null;
  const _ = `${t}%`, h = `${e}%`, m = `${r}%`, p = e > 0, B = e > 0 && r <= 20;
  return /* @__PURE__ */ s(
    "div",
    {
      "aria-label": `${o} comparison bar with ${t}% on the left, ${e}% draw in the middle, and ${r}% on the right.`,
      className: a.comparisonContainer,
      "data-cxy-name": "comparison",
      role: "region",
      ...g,
      children: [
        /* @__PURE__ */ s("div", { className: a.valuesContainer, children: [
          /* @__PURE__ */ n("span", { className: a.value, "data-testid": "comparison-left", children: /* @__PURE__ */ s(d, { className: a.leftBadge, children: [
            t,
            "%"
          ] }) }),
          /* @__PURE__ */ s("div", { className: a.label, children: [
            o,
            " ",
            l && /* @__PURE__ */ n(v, { children: l })
          ] }),
          /* @__PURE__ */ n("span", { className: a.value, "data-testid": "comparison-right", children: /* @__PURE__ */ s(d, { className: a.rightBadge, children: [
            r,
            "%"
          ] }) })
        ] }),
        /* @__PURE__ */ s("div", { className: c(a.progressBarContainer, { [a.hasMiddleValue]: p }), children: [
          /* @__PURE__ */ n(
            "div",
            {
              className: `${a.progressBar} ${a.leftBar}`,
              "data-testid": "comparison-left-bar",
              style: { width: _ }
            }
          ),
          /* @__PURE__ */ n(
            "div",
            {
              className: a.separatorContainer,
              "data-testid": "comparison-middle-bar",
              style: {
                width: e ? `${e}%` : void 0
              },
              children: e > 0 && /* @__PURE__ */ s(d, { className: c(a.middleBadge, { [a.badgeRightAligned]: B }), children: [
                i,
                " ",
                h
              ] })
            }
          ),
          /* @__PURE__ */ n(
            "div",
            {
              className: `${a.progressBar} ${a.rightBar}`,
              "data-testid": "comparison-right-bar",
              style: { width: m }
            }
          )
        ] })
      ]
    }
  );
};
export {
  k as Comparison
};
